import { Box, Button, Stack, Tooltip, Typography } from '@mui/material'
import { OrderAlerts } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { CheckmarkIcon, CloseButton, EditIcon, IconButton, useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'
import { IInspectContainerFormData } from './InspectContainer'
interface Props {
  order: IInspectContainerFormData
  isContainerCheckRequired?: boolean
  onEdit?: (order: IInspectContainerFormData) => void
  onRemove?: (order: IInspectContainerFormData) => void
  hideHoldEnforcement?: boolean
}

export const OrderListItem: FC<Props> = ({ order, isContainerCheckRequired, onEdit, onRemove, hideHoldEnforcement }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Stack mb='1rem' gap={theme.customSpacing.m}>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Box>
          <Stack display='flex' flexDirection={'row'}>
            {order.isChecked && (
              <CheckmarkIcon sx={{ color: theme.palette.success.main, mr: '.75rem' }} />
            )}
            <Typography variant='subtitle1'>{order.containerNumber}</Typography>
          </Stack>
        </Box>

        <Box>
          {isContainerCheckRequired && !order.isChecked && onEdit && (
            <Button
              variant='contained'
              color='inherit'
              onClick={() => onEdit(order)}
              data-cy={`gate-${order.direction === 'Inbound' ? 'in' : 'out'}-check-order-${order.containerNumber}-btn`}
            >
              {t('check', 'Check')}
            </Button>
          )}

          {(!isContainerCheckRequired || order.isChecked) && onEdit && (
            <Tooltip title={t('edit', 'Edit')}>
              <IconButton sx={{ mr: '.5rem' }} onClick={() => onEdit(order)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}

          {onRemove && <CloseButton onClose={() => onRemove(order)} />}
        </Box>
      </Stack>

      <OrderAlerts
        status={order.status}
        order={order}
        direction={order.direction}
        isOnTerminal={order.isOnTerminal}
        plannedYardLocation={order.plannedYardLocation}
        noMargin
        hideHoldEnforcement={hideHoldEnforcement}
      />

    </Stack>
  )
}
